export default __webpack_public_path__ + "locales/ru/Webhooks.json?hash=7af70f3fcedf8502fc5102df8fc5f7fd";